<template>
  <v-app id="inspire" style="background-color: #ececec">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {};
  },
};
</script>

<style>
html body *,
html body .v-application .text-subtitle-2 {
  font-family: Arial, sans-serif !important;
}

html body .v-btn {
  font-family: Ubuntu, sans-serif;
  font-weight: bolder;
}

body {
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
}

html {
  height: -webkit-fill-available;
}
</style>